export default {
  namespaced: true,
  totem_logs: {
    title: "totem logs",
    data: "dados",
    host: "host",
    response: "resposta",
  },
};
